import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconMoveToGroup = () => {
  return (
    <g>
      <path
        d="m8.304.008 6.649.016c.54.002.984.41 1.04.936l.007.114v6.63c0 .108-.016.211-.046.31.02.064.034.131.04.2l.006.107v6.63c0 .54-.41.986-.935 1.043L14.95 16H1.057a1.05 1.05 0 0 1-1.043-.935l-.006-.114V8.304c0-.54.409-.986.935-1.043l.114-.006 6.197.006V1.058c0-.541.41-.987.935-1.043l.115-.007zM1.507 8.754v5.747h5.747V8.76l-5.747-.007zm7.246.008V14.5H14.5V8.77l-5.748-.008zm0-7.254v5.746h5.748V1.522l-5.748-.014zM1.196.147 1.28.22l3.225 3.225V1.757a.75.75 0 1 1 1.5 0v3.748a.5.5 0 0 1-.41.492l-.09.008H1.757a.75.75 0 1 1 0-1.5h1.688L.22 1.28A.75.75 0 0 1 1.196.147z"
        
      />
    </g>
  );
};


export default withIcon(IconMoveToGroup);
